export default function convertGatedContentLinks() {
    const $links = document.querySelectorAll('a[data-gated-content]');
    $links.forEach($elem => {
        const href = $elem.href;
        const parts = href.split('/');
        if (parts.length >= 5) {
            $elem.dataset.requestDocumentDownload = '';
            $elem.dataset.dlfileentryTypeName = 'Gated Content';
            $elem.dataset.groupId = parts[2];
            $elem.dataset.uuid = parts[5];
            $elem.href = '#';
        } else {
            console.warn(`Cannot convert link ${href} to gated content because of wrong link structure`);
        }
    });
}
